import styled from 'styled-components';

export const PageNavigation = styled.div`
  padding-top: 12px;
  text-align: center;
  font-variant-numeric: normal;
  font-feature-settings: normal;

  a,
  span {
    display: inline-block;
    margin: 0 9px;
  }

  small {
    display: block;
    margin-top: 9px;
  }
`;
